import React, { useEffect, useState, useMemo, useRef, useContext } from "react";
import { Box, Menu, MenuItem, Typography, Button } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import {
  GoogleMap,
  Marker,
  Polyline,
  HeatmapLayer, //importación del componente de Google Maps para mapa de calor, difuminados e intensidad
  useJsApiLoader,
  TrafficLayer,
  InfoWindow,
  Circle,
} from "@react-google-maps/api";
import { socketWex } from "../../utils/Socket";
import { AuthContext } from "../../Auth/Context";
import useWexClient from "../../hooks/Clients/wexClient,";
import wer4u from "../../assets/Markers/Wer4u-icono.png";
import wer4u_busy from "../../assets/Markers/Wer4u-busy1.png";
import wer4u_avaible from "../../assets/Markers/Wer4u-avaible1.png";
import wer4u_attention from "../../assets/Markers/Wer4u-atention1.png";
import wer4u_waiting from "../../assets/Markers/Wer4u-WAITING.png";
// Markers de Bases
import AdjusterBaseIcon from "../../assets/Markers/Adjuster_Base_Icon.png";
import AdjusterTemporalBase from "../../assets/Markers/Adjuster_BaseTemporal-Icon.png";
import MarkerSearchBase from "../../assets/Markers/nw_BASE.png";
//
import Incident from "../../assets/Markers/incidente-marker.png";
import alfiler from "../../assets/alfiler.png";
import MobileCallModal from "../molecules/MobileCallModal";

const libraries = ["visualization", "geometry"];
const HEATMAP_GROUP_RADIUS = 500;
// Configuración de visualización para HeatmapLayer
const getHeatmapRadius = (zoomLevel) => {
  const z = typeof zoomLevel === "number" ? zoomLevel : 6;
  if (z <= 5) return 60;
  if (z === 6) return 50;
  if (z === 7) return 40;
  if (z === 8) return 32;
  if (z === 9) return 26;
  if (z === 10) return 20;
  if (z === 11) return 16;
  if (z === 12) return 12;
  return 18;
};

const HeatmapMarkers = React.memo(({ data }) => {
  return data.map((point) => (
    <Marker
      key={`${point.folio}-${point.location.lat()}-${point.location.lng()}`}
      position={{
        lat: point.location.lat(),
        lng: point.location.lng(),
      }}
      icon={{
        url: alfiler,
        scaledSize: new window.google.maps.Size(20, 20),
        anchor: new window.google.maps.Point(15, 30),
      }}
      title={`Folio: ${point.folio}\nMinutos: ${
        point.minutes
      }\nAtendido a tiempo: ${point.attendedOnTime ? "Sí" : "No"}`}
    />
  ));
});

const heatmapGradient = [
  "rgba(0, 255, 0, 0)",
  "rgba(0, 255, 0, 1)",
  "rgba(120, 255, 0, 1)",
  "rgba(255, 255, 0, 1)",
  "rgba(255, 180, 0, 1)",
  "rgba(255, 100, 0, 1)",
  "rgba(255, 0, 0, 1)",
];

function MapDisplay({
  centerLat = 19.437134406415517,
  centerLng = -99.1437782513343,
  zoom = 6,
  receive,
  users = [],
  selectedOption = null,
  selectedAgent = null,
  data = [],
  registersLists = [],
  services = [],
  routeMarkers = [],
  routePolylines = [],
  onOpenIncidentModal = () => {},
  onPlaceIncident = () => {},
  showTraffic = false,
  onSelectAdjuster = () => {},
  incidentLocation = null,
  baseLocation = null,
  baseLabel = "Base buscada",
  routeInfo = null,
  selectedRoute = null,
  checkInMarkers = [],
  AdjusterBases = [],
  permissions = {},
  onBaseMarkerClick = () => {},
  onCtrlClick = () => {},
}) {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
    version: "3.64",
  });
  const [mapInstance, setMapInstance] = useState(null);
  //const canCreateIncident= "";

  const { payload } = useContext(AuthContext) || {};
  const { markedAdjusters } = useWexClient();
  const canCreateIncident = permissions?.incidents?.create === true;


  
  const [selectedZone, setSelectedZone] = useState(null);
  const [zoneInfo, setZoneInfo] = useState(null);
  const zoomTimerRef = useRef(null);
  const [mapCenter, setMapCenter] = useState({
    lat: centerLat,
    lng: centerLng,
  }); // ✅ Centro dinámico del mapa
  const [currentZoom, setCurrentZoom] = useState(zoom);

  useEffect(() => {
    setCurrentZoom(zoom);
  }, [zoom]);

  useEffect(() => {}, [selectedZone]);
  const [selectedUser, setSelectedUser] = useState(null);

  const [contextMenu, setContextMenu] = useState(null);
  const [rightClickLocation, setRightClickLocation] = useState(null);

  // 🟢 ESTADO 1: InfoWindow persistente por CLICK (con botón de llamar)
  const [clickedAdjuster, setClickedAdjuster] = useState(null);

  // 🟢 ESTADO 2: InfoWindow temporal por HOVER (sin botón de llamar)
  const [hoveredAdjuster, setHoveredAdjuster] = useState(null);

  // Ref para limpiar el temporizador de 2.3 segundos del hover
  const hoverTimerRef = useRef(null);
  const [selectedBase, setSelectedBase] = useState(null);

  // Estado para MobileCallModal
  const [callModalOpen, setCallModalOpen] = useState(false);
  const [callAgent, setCallAgent] = useState(null);
  const [callingAdjuster, setCallingAdjuster] = useState(false);

  const mapStyles = {
    width: "100vw",
    height: "103vh",
  };

  const getGridKey = (lat, lng, cellSize) => {
    const latCell = Math.floor(lat / cellSize);
    const lngCell = Math.floor(lng / cellSize);

    return `${latCell}_${lngCell}`;
  };

  //Transformación de datos a formato de Google Maps
  const heatmapData = useMemo(() => {
    if (
      receive !== "HeatMap" ||
      !isLoaded ||
      !window.google ||
      !window.google.maps ||
      !window.google.maps.geometry
    ) {
      return [];
    }

    const points = users
      .map((u) => ({
        location: new window.google.maps.LatLng(Number(u.lat), Number(u.lng)),
        folio: u.folio,
        minutes: Number(u.minutes) || 1,
        attendedOnTime: u.attendedOnTime,
        createdAt: u.createdAt,
        closeAt: u.closeAt,
      }))
      .filter(
        (point) =>
          Number.isFinite(point.location.lat()) &&
          Number.isFinite(point.location.lng()),
      );

    if (!points.length) {
      return [];
    }

    // Aproximación de 500 metros en grados
    const cellSize = 0.005;

    // Agrupamos las incidencias por celda
    const grid = new Map();

    points.forEach((point) => {
      const lat = point.location.lat();
      const lng = point.location.lng();

      const key = getGridKey(lat, lng, cellSize);

      if (!grid.has(key)) {
        grid.set(key, []);
      }

      grid.get(key).push(point);
    });

    // Calculamos la concentración de cada punto
    const result = points.map((point) => {
      const lat = point.location.lat();
      const lng = point.location.lng();

      const latCell = Math.floor(lat / cellSize);
      const lngCell = Math.floor(lng / cellSize);

      let nearbyCount = 0;

      // Solo revisamos la celda donde está el punto
      // y las celdas que la rodean
      for (let i = -1; i <= 1; i++) {
        for (let j = -1; j <= 1; j++) {
          const key = `${latCell + i}_${lngCell + j}`;
          const nearbyPoints = grid.get(key) || [];

          nearbyPoints.forEach((otherPoint) => {
            const distance =
              window.google.maps.geometry.spherical.computeDistanceBetween(
                point.location,
                otherPoint.location,
              );

            if (distance <= HEATMAP_GROUP_RADIUS) {
              nearbyCount++;
            }
          });
        }
      }

      return {
        ...point,
        concentration: nearbyCount,
      };
    });

    // Obtener valores de concentración
    const concentrationValues = result.map((point) => point.concentration);

    const minConcentration = Math.min(...concentrationValues);
    const maxConcentration = Math.max(...concentrationValues);

    // Normalizar intensidad del Heatmap
    return result.map((point) => {
      let normalizedWeight = 1;

      if (maxConcentration !== minConcentration) {
        normalizedWeight =
          1 +
          ((point.concentration - minConcentration) /
            (maxConcentration - minConcentration)) *
            9;
      }

      return {
        ...point,
        weight: normalizedWeight,
      };
    });
  }, [users, receive, isLoaded]);

  const heatmapLocations = useMemo(() => {
    return heatmapData.map((point) => point.location);
  }, [heatmapData]);

  const getZoneColor = (concentration, concentrations) => {
    if (!concentrations?.length) {
      return "#42e66c";
    }

    const sorted = [...concentrations].sort((a, b) => a - b);

    const getPercentile = (percentile) => {
      const index = Math.floor(percentile * (sorted.length - 1));

      return sorted[index];
    };

    const p25 = getPercentile(0.25);
    const p50 = getPercentile(0.5);
    const p75 = getPercentile(0.75);

    if (concentration >= p75) return "#f44336"; // Rojo
    if (concentration >= p50) return "#ff9800"; // Naranja
    if (concentration >= p25) return "#ffd740"; // Amarillo

    return "#42e66c"; // Verde
  };
  const handleHeatmapClick = (event) => {
    // Si viene de un evento de React-Google-Maps, el evento nativo del DOM está en event.domEvent
    const nativeEvent = event?.domEvent;

    if (nativeEvent && event?.latLng) {
      const isMac =
        /Mac|iPod|iPhone|iPad/.test(navigator.userAgent) || nativeEvent.metaKey;

      let shouldTrigger = false;

      if (isMac) {
        // En Mac: Cmd + Click (metaKey) O Click derecho (button === 2)
        shouldTrigger = nativeEvent.metaKey || nativeEvent.button === 2;
      } else {
        // En Windows: Ctrl + Click (ctrlKey)
        shouldTrigger = nativeEvent.ctrlKey;
      }

      if (shouldTrigger) {
        // Si fue click derecho, prevenimos el menú contextual por defecto
        if (
          nativeEvent.button === 2 &&
          typeof nativeEvent.preventDefault === "function"
        ) {
          nativeEvent.preventDefault();
        }

        onCtrlClick(
          {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          },
          nativeEvent,
        );
        return;
      }
    }

    if (receive !== "HeatMap" || !event?.latLng || heatmapData.length === 0) {
      return;
    }

    const clickPoint = event.latLng;

    let nearestPoint = null;
    let minDistance = Infinity;

    heatmapData.forEach((point) => {
      const distance =
        window.google.maps.geometry.spherical.computeDistanceBetween(
          clickPoint,
          point.location,
        );

      if (distance < minDistance) {
        minDistance = distance;
        nearestPoint = point;
      }
    });

    console.log("Distancia al punto más cercano:", minDistance);
    console.log("Punto más cercano:", nearestPoint);

    const centerPoint = nearestPoint.location;

    const radius = 500;

    const incidents = heatmapData.filter((point) => {
      const distance =
        window.google.maps.geometry.spherical.computeDistanceBetween(
          centerPoint,
          point.location,
        );

      return distance <= radius;
    });

    console.log("Incidencias encontradas:", incidents.length);

    setSelectedZone({
      lat: centerPoint.lat(),
      lng: centerPoint.lng(),
    });

    console.table(
      incidents.map((i) => ({
        folio: i.folio,
        minutes: i.minutes,
        weight: i.weight,
      })),
    );

    const zoneMaxConcentration = Math.max(
      ...incidents.map((p) => p.concentration || 0),
    );

    setZoneInfo({
      total: incidents.length,
      radius: 500,
      color: getZoneColor(
        zoneMaxConcentration,
        heatmapData.map((p) => p.concentration || 0),
      ),
    });
  };

  const setColors = (index) => {
    const colors = [
      "#80E152",
      "#6AB1EC",
      "#BC84E9",
      "#5D0808",
      "#5B0A5F",
      "#F095F4",
      "#F5E06C",
      "#1E460C",
    ];
    return colors[index % colors.length];
  };

  const formatDateTime = (isoDateStr) => {
    if (!isoDateStr) return "";
    const date = new Date(isoDateStr);
    if (isNaN(date.getTime())) return String(isoDateStr);

    const pad = (n) => n.toString().padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    setSelectedUser(null);
    if (receive === "CheckIn" && selectedAgent && users.length > 0) {
      const matchingUsers =
        selectedAgent === "00001"
          ? users.filter((u) => u.location)
          : users.filter((u) => u.id === selectedAgent && u.location);

      if (matchingUsers.length === 0) return;

      const resolvedUsers = matchingUsers.map((user) => {
        const [lat, lng] = user.location.split(",").map(Number);

        const fullDate = new Date(user.date);
        const formattedDate = fullDate.toLocaleDateString("es-MX", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });

        const formattedTime = fullDate.toLocaleTimeString("es-MX", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });

        return {
          ...user,
          lat,
          lng,
          date: formattedDate,
          time: formattedTime,
          Initials: getInitials(user.name),
        };
      });
      setSelectedUser(resolvedUsers);
    }
  }, [receive, selectedAgent, users]);

  const parseLocation = (userLocation) => {
    if (!userLocation) return null;
    let lat, lng;
    if (typeof userLocation === "string") {
      const parts = userLocation.split(",");
      lat = Number(parts[0]);
      lng = Number(parts[1]);
    } else if (typeof userLocation === "object") {
      lat = Number(userLocation.lat);
      lng = Number(userLocation.lng);
    }
    if (isNaN(lat) || isNaN(lng)) return null;
    return { lat, lng };
  };

  const calculateBounds = (markers) => {
    if (!window.google || !markers.length) return;
    const bounds = new window.google.maps.LatLngBounds();
    markers.forEach((marker) => {
      if (marker.lat && marker.lng) {
        bounds.extend(new window.google.maps.LatLng(marker.lat, marker.lng));
      }
    });
    return bounds;
  };

  useEffect(() => {
    if (receive === "Real-Time") return;

    if (
      mapInstance &&
      selectedUser &&
      Array.isArray(selectedUser) &&
      selectedUser.length > 0
    ) {
      const bounds = calculateBounds(selectedUser);
      if (bounds) mapInstance.fitBounds(bounds);
    }
  }, [selectedUser, mapInstance, receive]);

  const lastCenteredAgentRef = useRef(null);

  const selectedAgentPosition = useMemo(() => {
    if (!selectedAgent || selectedAgent === "00001" || !data.length)
      return null;
    const user = data.find(
      (u) =>
        String(u.userId).trim() === String(selectedAgent).trim() &&
        u.userLocation,
    );
    return user ? parseLocation(user.userLocation) : null;
  }, [data, selectedAgent]);

  useEffect(() => {
    if (!mapInstance || !selectedAgentPosition) return;

    if (lastCenteredAgentRef.current === selectedAgent) return;

    lastCenteredAgentRef.current = selectedAgent;

    setMapCenter(selectedAgentPosition);
    mapInstance.panTo(selectedAgentPosition);
  }, [selectedAgent, selectedAgentPosition, mapInstance]);

  useEffect(() => {
    if (!selectedAgent || selectedAgent === "00001") {
      lastCenteredAgentRef.current = null;
      setMapCenter({
        lat: centerLat,
        lng: centerLng,
      });
    }
  }, [selectedAgent, centerLat, centerLng]);

  useEffect(() => {
    if (mapInstance && incidentLocation) {
      mapInstance.setCenter(incidentLocation);
    }
  }, [mapInstance, incidentLocation]);

  useEffect(() => {
    if (mapInstance && baseLocation) {
      mapInstance.panTo(baseLocation);
      mapInstance.setZoom(14);
    }
  }, [mapInstance, baseLocation]);

  const isRealTimeMap = receive === "Real-Time";

  const handleMapRightClick = (event) => {
    const nativeEvent = event?.domEvent;
    const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);

    if (isMac && event?.latLng) {
      if (nativeEvent && typeof nativeEvent.preventDefault === "function") {
        nativeEvent.preventDefault();
      }
      onCtrlClick(
        {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        },
        nativeEvent,
      );
      return;
    }

    if (!isRealTimeMap || !event?.latLng) return;

    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const position = { lat, lng };

    setRightClickLocation(position);
    setContextMenu({
      mouseX: event.domEvent?.clientX ?? 0,
      mouseY: event.domEvent?.clientY ?? 0,
    });

    if (event.domEvent) {
      event.domEvent.preventDefault();
      event.domEvent.stopPropagation();
    }
  };

  const handleCloseContextMenu = () => {
    setContextMenu(null);
    setRightClickLocation(null);
  };

  const handleCopyCoordinates = async () => {
    if (!rightClickLocation) return;

    const text = `${rightClickLocation.lat.toFixed(6)}, ${rightClickLocation.lng.toFixed(6)}`;

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        window.prompt("Copiar coordenadas", text);
      }
    } catch (error) {
      console.error("No se pudieron copiar las coordenadas", error);
    } finally {
      handleCloseContextMenu();
    }
  };

  const handleOpenIncidentForm = (location) => {
    if (!location) return;
    onOpenIncidentModal?.(location);
    handleCloseContextMenu();
  };

  const handleCenterMapHere = () => {
    if (!rightClickLocation || !mapInstance) {
      handleCloseContextMenu();
      return;
    }

    setMapCenter(rightClickLocation);
    mapInstance.panTo(rightClickLocation);
    handleCloseContextMenu();
  };

  const getInitials = (name) => {
    if (typeof name !== "string" || !name) return "";

    const userPart = name.split("@")[0];
    const parts = userPart.split(/[._\-\s]+/);
    let initials = "";

    if (parts.length > 1 && parts[0] && parts[parts.length - 1]) {
      initials = parts[0][0] + parts[parts.length - 1][0];
    } else if (parts[0] && parts[0].length > 1) {
      initials = parts[0][0] + parts[0][1];
    } else if (parts[0]) {
      initials = parts[0][0];
    }

    return initials.toUpperCase();
  };

  useEffect(() => {
    if (!mapInstance) return;

    const mapDiv = mapInstance.getDiv();

    const preventContextMenu = (e) => {
      e.preventDefault();
    };

    mapDiv.addEventListener("contextmenu", preventContextMenu);

    return () => {
      mapDiv.removeEventListener("contextmenu", preventContextMenu);
    };
  }, [mapInstance]);

  // 🔴 MANEJADORES DE HOVER
  const handleMarkerMouseOver = (u, pos) => {
    // Si la tarjeta completa ya está abierta por click, ignoramos el hover
    if (clickedAdjuster?.userId === u.userId) return;

    // Si había un temporizador corriendo para ocultar el hover, lo cancelamos
    if (hoverTimerRef.current) {
      clearTimeout(hoverTimerRef.current);
    }

    setHoveredAdjuster({ ...u, _pos: pos });
  };

  const handleMarkerMouseOut = () => {
    // Cuando el usuario retira el mouse, dejamos visible la ventana durante 2.3 segundos (2300 ms)
    if (hoverTimerRef.current) {
      clearTimeout(hoverTimerRef.current);
    }

    hoverTimerRef.current = setTimeout(() => {
      setHoveredAdjuster(null);
    }, 2300);
  };

  // 🔵 MANEJADOR DE CLICK EN EL MARCADOR (Abre el InfoWindow con botón)
  const handleMarkerClick = (u, pos, labelText) => {
    // Cancela cualquier timer de hover pendiente
    if (hoverTimerRef.current) {
      clearTimeout(hoverTimerRef.current);
    }
    setHoveredAdjuster(null); // Oculta la vista rápida sin botón

    // Asigna el estado de click
    setClickedAdjuster({ ...u, _pos: pos });

    // Notifica la selección del ajustador a props
    onSelectAdjuster({ ...u, ...pos, initials: labelText });
  };

  const resetCallState = () => {
    setCallModalOpen(false);
    setCallAgent(null);
    setClickedAdjuster(null);
  };

  const handleCallFromMap = (adjuster) => {
    if (!adjuster || !payload?._id || callingAdjuster) return;

    setCallingAdjuster(true);

    const body = {
      cabinId: payload._id,
      agentId: adjuster.userId,
      serviceId: payload?.service,
      isUserCabin: true,
    };

    markedAdjusters(body)
      .then((response) => {
        if (response?.success) {
          const { from, to } = response.data;
          setCallAgent({
            _id: payload._id,
            name: adjuster.name || adjuster.userCode || "Ajustador",
            from,
            to,
          });
          setCallModalOpen(true);
          setClickedAdjuster(null);
        } else {
          console.warn("La API respondió pero sin éxito:", response?.message);
        }
      })
      .catch((error) => {
        console.error("Error al iniciar llamada:", error);
      })
      .finally(() => {
        setCallingAdjuster(false);
      });
  };

  const getStatusIcon = (u) => {
    if (u.waiting_decision === true) return wer4u_waiting;
    if (u.busy === true) return wer4u_busy;
    if (u.preselected === true) return wer4u_attention;
    return wer4u_avaible;
  };

  const handleZoomChanged = () => {
    if (!mapInstance) return;

    clearTimeout(zoomTimerRef.current);

    zoomTimerRef.current = setTimeout(() => {
      const newZoom = mapInstance.getZoom();

      setCurrentZoom((previousZoom) =>
        newZoom !== previousZoom ? newZoom : previousZoom,
      );
    }, 100);
  };
  useEffect(() => {
    if (!payload) return;

    const joinCallUsers = () => {
      socketWex.emit("join-user-calls", { idUser: payload._id }, (response) => {
        if (!response?.success) {
          console.error("Error al unirse a call users:", response?.message);
        }
      });
    };

    const handleSocketDisconnect = (reason) => {
      console.warn("Socket desconectado:", reason);
    };

    const handleCallStart = (data) => {
      console.log("Llamada iniciada:", data);
    };

    const handleCallEnd = (data) => {
      console.log("Llamada finalizada:", data);
      resetCallState();
    };

    socketWex.on("connect", joinCallUsers);
    socketWex.on("disconnect", handleSocketDisconnect);
    socketWex.on("user-call-started", handleCallStart);
    socketWex.on("user-call-ended", handleCallEnd);
    if (socketWex.connected) {
      joinCallUsers();
    } else {
      socketWex.connect();
    }

    return () => {
      socketWex.off("connect", joinCallUsers);
      socketWex.off("disconnect", handleSocketDisconnect);
      socketWex.off("user-call-started", handleCallStart);
      socketWex.off("user-call-ended", handleCallEnd);
    };
  }, [payload]);

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <GoogleMap
        mapContainerStyle={mapStyles}
        center={mapCenter}
        zoom={currentZoom}
        onClick={handleHeatmapClick}
        onLoad={(map) => {
          setMapInstance(map);
          setCurrentZoom(map.getZoom());
        }}
        options={{
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          gestureHandling: "greedy",
        }}
        onRightClick={handleMapRightClick}
      >
        {showTraffic && <TrafficLayer />}

        {receive === "Routes" &&
          Array.isArray(routeMarkers) &&
          routeMarkers.map((user) => (
            <Marker
              key={`${user.id}-${user.lat}-${user.lng}-${user.date}`}
              position={{ lat: user.lat, lng: user.lng }}
              icon={wer4u}
              title={`${
                user.label === "A" ? "Inicio de ruta" : "Final de ruta"
              }\n${user.usuario || ""}\n${user.name || ""}\nFecha y hora: ${user.date} hrs.`}
              label={{
                text: user.label,
                color: "white",
                fontSize: "20px",
                fontWeight: "bold",
                fontFamily: "Raleway, sans-serif",
              }}
            />
          ))}

        {receive === "Routes" &&
          Array.isArray(routePolylines) &&
          routePolylines.map(({ path }, index) => (
            <Polyline
              key={`polyline-${index}`}
              path={path}
              options={{
                strokeColor: setColors(index),
                strokeOpacity: 0.8,
                strokeWeight: 4,
              }}
            />
          ))}

        {receive === "CheckIn" &&
          checkInMarkers.length > 0 &&
          checkInMarkers.map((user) => (
            <Marker
              key={`${user.id}-${user.lat}-${user.lng}`}
              position={{ lat: user.lat, lng: user.lng }}
              icon={wer4u}
              label={{
                text: user.Initials,
                color: "white",
                fontSize: "20px",
                fontWeight: "bold",
                fontFamily: "Raleway, sans-serif",
              }}
              title={`${user.usuario || ""}\n${user.name || ""}\nFecha: ${user.date} ${user.time} hrs.`}
            />
          ))}

        {receive === "Real-Time" &&
          Array.isArray(data) &&
          data.map((u) => {
            if (!u.userLocation) return null;
            const pos = parseLocation(u.userLocation);
            if (!pos) return null;

            const labelText = u.name;
            const isClicked = clickedAdjuster?.userId === u.userId;
            const isHovered =
              hoveredAdjuster?.userId === u.userId && !isClicked;

            return (
              <React.Fragment key={`${u.userId}-${pos.lat}-${pos.lng}`}>
                <Marker
                  position={pos}
                  key={`${u.userId}-${u.waiting_decision}-${u.busy}-${u.preselected}`}
                  icon={getStatusIcon(u)}
                  label={{
                    text: labelText,
                    color: "#090909e3",
                    fontSize: labelText.length > 3 ? "14px" : "16px",
                    fontWeight: "bold",
                    fontFamily: "Raleway, sans-serif",
                  }}
                  onClick={() => handleMarkerClick(u, pos, labelText)}
                  onMouseOver={() => handleMarkerMouseOver(u, pos)}
                  onMouseOut={handleMarkerMouseOut}
                />

                {/* 1. INFOWINDOW POR HOVER (Sin botón de llamada, se auto-cierra tras 2.3s) */}
                {isHovered && (
                  <InfoWindow
                    position={pos}
                    options={{
                      pixelOffset: new window.google.maps.Size(0, -50),
                      disableAutoPan: true,
                    }}
                    onCloseClick={() => setHoveredAdjuster(null)}
                  >
                    <Box
                      sx={{ p: 1, minWidth: 200 }}
                      onMouseEnter={() => {
                        // Mantener abierto mientras el mouse esté sobre la ventana
                        if (hoverTimerRef.current)
                          clearTimeout(hoverTimerRef.current);
                      }}
                      onMouseLeave={handleMarkerMouseOut}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: "bold",
                          color: "#1a73e8",
                          mb: 0.5,
                          fontSize: "1rem",
                        }}
                      >
                        {u.userCode || "N/A"}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, color: "#3c4043", mb: 0.5 }}
                      >
                        user: {u.user || "N/A"}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          color: "#70757a",
                          borderTop: "1px solid #e8eaed",
                          pt: 0.5,
                          mt: 0.5,
                          fontSize: "0.8rem",
                        }}
                      >
                        Última conexión:
                        <br />
                        <strong>
                          {u.locationDt
                            ? formatDateTime(u.locationDt)
                            : "Sin conexión"}
                        </strong>
                      </Typography>
                    </Box>
                  </InfoWindow>
                )}

                {/* 2. INFOWINDOW POR CLICK (Con botón de llamada, permanece abierto) */}
                {isClicked && (
                  <InfoWindow
                    position={pos}
                    options={{
                      pixelOffset: new window.google.maps.Size(0, -50),
                    }}
                    onCloseClick={() => setClickedAdjuster(null)}
                  >
                    <Box sx={{ p: 1.5, minWidth: 240 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: "bold",
                          color: "#1a73e8",
                          mb: 0.5,
                          fontSize: "1.1rem",
                        }}
                      >
                        {u.userCode || "N/A"}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, color: "#3c4043", mb: 0.5 }}
                      >
                        user: {u.user || "N/A"}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          color: "#70757a",
                          borderTop: "1px solid #e8eaed",
                          pt: 1,
                          mt: 1,
                          fontSize: "0.85rem",
                        }}
                      >
                        Última conexión:
                        <br />
                        <strong>
                          {u.locationDt
                            ? formatDateTime(u.locationDt)
                            : "Sin conexión"}
                        </strong>
                      </Typography>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<PhoneIcon />}
                        disabled={callingAdjuster}
                        onClick={() => handleCallFromMap(u)}
                        sx={{
                          mt: 1.5,
                          width: "100%",
                          backgroundColor: "#9a2edb",
                          textTransform: "none",
                          fontFamily: "Raleway, sans-serif",
                          fontWeight: 600,
                          fontSize: "0.85rem",
                          "&:hover": {
                            backgroundColor: "#7b1fb8",
                          },
                        }}
                      >
                        {callingAdjuster ? "Conectando..." : "Llamar"}
                      </Button>
                    </Box>
                  </InfoWindow>
                )}
              </React.Fragment>
            );
          })}

        {receive === "HeatMap" && heatmapData.length > 0 && (
          <>
            <HeatmapLayer
              data={heatmapLocations}
              options={{
                radius: getHeatmapRadius(currentZoom),
                opacity: 0.85,
                gradient: heatmapGradient,
                dissipating: true,
                maxIntensity: 20,
              }}
            />
            {selectedZone && (
              <Circle
                center={selectedZone}
                radius={500} // por ahora fijo
                options={{
                  fillColor: zoneInfo?.color || "#2196f3",
                  fillOpacity: 0.15,
                  strokeColor: zoneInfo?.color || "#1976d2",
                  strokeOpacity: 0.9,
                  strokeWeight: 2,
                  clickable: false,
                }}
              />
            )}

            {selectedZone && zoneInfo && (
              <InfoWindow
                position={selectedZone}
                onCloseClick={() => {
                  setSelectedZone(null);
                  setZoneInfo(null);
                }}
              >
                <Box sx={{ p: 1 }}>
                  <Typography variant="subtitle2" fontWeight="bold">
                    Zona seleccionada
                  </Typography>

                  <Typography variant="body2">
                    Incidencias: <b>{zoneInfo.total}</b>
                  </Typography>

                  <Typography variant="body2">
                    Radio: <b>500 m</b>
                  </Typography>
                </Box>
              </InfoWindow>
            )}

            <HeatmapMarkers data={heatmapData} />
          </>
        )}

        {receive === "HeatMap" &&
          Array.isArray(AdjusterBases) &&
          AdjusterBases.length > 0 &&
          AdjusterBases.map((base) => {
            const isConfirmed =
              base?.isConfirmed === true ||
              String(base?.isConfirmed).toLowerCase() === "true";

            return (
              <React.Fragment key={`base-${base.id}`}>
                <Marker
                  position={{ lat: base.lat, lng: base.lng }}
                  icon={{
                    url: isConfirmed ? AdjusterBaseIcon : AdjusterTemporalBase,
                    scaledSize: new window.google.maps.Size(55, 55),
                    anchor: new window.google.maps.Point(20, 40),
                  }}
                  title={base.description}
                  zIndex={isConfirmed ? 1000 : 500}
                  onClick={() => {
                    setSelectedBase(base);
                    onBaseMarkerClick?.(base);
                  }}
                />
                {selectedBase?.id === base.id && (
                  <InfoWindow
                    position={{ lat: base.lat, lng: base.lng }}
                    options={{
                      pixelOffset: new window.google.maps.Size(0, -42),
                    }}
                    onCloseClick={() => setSelectedBase(null)}
                  >
                    <Box sx={{ p: 1, minWidth: 180 }}>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          fontWeight: "bold",
                          color: "#1a73e8",
                          mb: 0.5,
                        }}
                      >
                        {base.description}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          display: "block",
                          color: "#70757a",
                          fontSize: "0.8rem",
                        }}
                      >
                        ID: {base.id}
                      </Typography>
                    </Box>
                  </InfoWindow>
                )}
              </React.Fragment>
            );
          })}

        {incidentLocation && (
          <React.Fragment>
            <Marker
              position={incidentLocation}
              icon={Incident}
              title={`Incidente${routeInfo ? ` - Tiempo estimado: ${routeInfo.duration}` : ""}`}
              onClick={(event) => {
                if (event?.domEvent) {
                  event.domEvent.preventDefault();
                  event.domEvent.stopPropagation();
                }
                handleOpenIncidentForm(incidentLocation);
              }}
            />
            {routeInfo && (
              <InfoWindow
                position={incidentLocation}
                options={{
                  pixelOffset: new window.google.maps.Size(0, -50),
                  disableAutoPan: true,
                }}
              >
                <Box sx={{ p: 1, minWidth: 220, maxWidth: 260 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: "bold", color: "#0c4a91", mb: 0.5 }}
                  >
                    Información de Ruta
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 0.25 }}>
                    <strong>Distancia:</strong> {routeInfo.distance}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 0.25 }}>
                    <strong>Tiempo de arribo:</strong>{" "}
                    {routeInfo.durationInTraffic}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "bold", color: "#2b87f0" }}
                  >
                    Estimado *
                  </Typography>
                </Box>
              </InfoWindow>
            )}
          </React.Fragment>
        )}

        {baseLocation && (
          <React.Fragment>
            <Marker
              position={baseLocation}
              icon={{
                url: MarkerSearchBase,
                scaledSize: new window.google.maps.Size(55, 55),
                anchor: new window.google.maps.Point(22, 45),
              }}
              title={`${baseLabel}: ${baseLocation.lat.toFixed(6)}, ${baseLocation.lng.toFixed(6)}`}
              onClick={() => onBaseMarkerClick?.()}
            />
            <InfoWindow
              position={baseLocation}
              options={{
                pixelOffset: new window.google.maps.Size(0, -47),
                disableAutoPan: false,
              }}
            >
              <Box sx={{ p: 1, minWidth: 180 }}>
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: "bold", color: "#0c4a91", mb: 0.5 }}
                >
                  {baseLabel}
                </Typography>
                <Typography variant="body2" sx={{ color: "#3c4043" }}>
                  <strong>Lat:</strong> {baseLocation.lat.toFixed(6)}
                </Typography>
                <Typography variant="body2" sx={{ color: "#3c4043" }}>
                  <strong>Lng:</strong> {baseLocation.lng.toFixed(6)}
                </Typography>
              </Box>
            </InfoWindow>
          </React.Fragment>
        )}

        {selectedRoute && Array.isArray(selectedRoute) && (
          <Polyline
            path={selectedRoute}
            options={{
              strokeColor: "#550b84",
              strokeOpacity: 0.6,
              strokeWeight: 8,
            }}
          />
        )}
      </GoogleMap>

      <Menu
        open={isRealTimeMap && Boolean(contextMenu)}
        onClose={handleCloseContextMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
        MenuListProps={{ sx: { minWidth: 220 } }}
      >
        {canCreateIncident && (
          <MenuItem
            onClick={() => {
              onPlaceIncident?.(rightClickLocation);
              handleCloseContextMenu();
            }}
          >
            <Typography variant="body2">Ubicar incidente aquí</Typography>
          </MenuItem>
        )}
        <MenuItem onClick={handleCopyCoordinates}>
          <Typography variant="body2">
            {rightClickLocation
              ? `${rightClickLocation.lat.toFixed(6)}, ${rightClickLocation.lng.toFixed(6)}`
              : "Copiar coordenadas"}
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleCenterMapHere}>
          <Typography variant="body2">Centrar mapa aquí</Typography>
        </MenuItem>
        <MenuItem onClick={handleCloseContextMenu}>
          <Typography variant="body2">Cerrar</Typography>
        </MenuItem>
      </Menu>

      <MobileCallModal
        open={callModalOpen}
        onClose={() => {
          resetCallState();
        }}
        agentData={callAgent}
        payload={payload}
      />
    </>
  );
}

export default MapDisplay;
